/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { assetsCreateSignedChatAttachmentURL } from "../funcs/assetsCreateSignedChatAttachmentURL.js";
import { assetsFetchImageFromURL } from "../funcs/assetsFetchImageFromURL.js";
import { assetsFetchOpenAPIv3FromURL } from "../funcs/assetsFetchOpenAPIv3FromURL.js";
import { assetsListAssets } from "../funcs/assetsListAssets.js";
import { assetsServeChatAttachment } from "../funcs/assetsServeChatAttachment.js";
import { assetsServeChatAttachmentSigned } from "../funcs/assetsServeChatAttachmentSigned.js";
import { assetsServeFunction } from "../funcs/assetsServeFunction.js";
import { assetsServeImage } from "../funcs/assetsServeImage.js";
import { assetsServeOpenAPIv3 } from "../funcs/assetsServeOpenAPIv3.js";
import { assetsUploadChatAttachment } from "../funcs/assetsUploadChatAttachment.js";
import { assetsUploadFunctions } from "../funcs/assetsUploadFunctions.js";
import { assetsUploadImage } from "../funcs/assetsUploadImage.js";
import { assetsUploadOpenAPIv3 } from "../funcs/assetsUploadOpenAPIv3.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreateSignedChatAttachmentURLResult } from "../models/components/createsignedchatattachmenturlresult.js";
import { ListAssetsResult } from "../models/components/listassetsresult.js";
import { UploadChatAttachmentResult } from "../models/components/uploadchatattachmentresult.js";
import { UploadFunctionsResult } from "../models/components/uploadfunctionsresult.js";
import { UploadImageResult } from "../models/components/uploadimageresult.js";
import { UploadOpenAPIv3Result } from "../models/components/uploadopenapiv3result.js";
import {
  CreateSignedChatAttachmentURLRequest,
  CreateSignedChatAttachmentURLSecurity,
} from "../models/operations/createsignedchatattachmenturl.js";
import {
  FetchImageFromURLRequest,
  FetchImageFromURLSecurity,
} from "../models/operations/fetchimagefromurl.js";
import {
  FetchOpenAPIv3FromURLRequest,
  FetchOpenAPIv3FromURLSecurity,
} from "../models/operations/fetchopenapiv3fromurl.js";
import {
  ListAssetsRequest,
  ListAssetsSecurity,
} from "../models/operations/listassets.js";
import {
  ServeChatAttachmentRequest,
  ServeChatAttachmentResponse,
  ServeChatAttachmentSecurity,
} from "../models/operations/servechatattachment.js";
import {
  ServeChatAttachmentSignedRequest,
  ServeChatAttachmentSignedResponse,
} from "../models/operations/servechatattachmentsigned.js";
import {
  ServeFunctionRequest,
  ServeFunctionResponse,
  ServeFunctionSecurity,
} from "../models/operations/servefunction.js";
import {
  ServeImageRequest,
  ServeImageResponse,
} from "../models/operations/serveimage.js";
import {
  ServeOpenAPIv3Request,
  ServeOpenAPIv3Response,
  ServeOpenAPIv3Security,
} from "../models/operations/serveopenapiv3.js";
import {
  UploadChatAttachmentRequest,
  UploadChatAttachmentSecurity,
} from "../models/operations/uploadchatattachment.js";
import {
  UploadFunctionsRequest,
  UploadFunctionsSecurity,
} from "../models/operations/uploadfunctions.js";
import {
  UploadImageRequest,
  UploadImageSecurity,
} from "../models/operations/uploadimage.js";
import {
  UploadOpenAPIv3AssetRequest,
  UploadOpenAPIv3AssetSecurity,
} from "../models/operations/uploadopenapiv3asset.js";
import { unwrapAsync } from "../types/fp.js";

export class Assets extends ClientSDK {
  /**
   * createSignedChatAttachmentURL assets
   *
   * @remarks
   * Create a time-limited signed URL to access a chat attachment without authentication.
   */
  async createSignedChatAttachmentURL(
    request: CreateSignedChatAttachmentURLRequest,
    security?: CreateSignedChatAttachmentURLSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreateSignedChatAttachmentURLResult> {
    return unwrapAsync(assetsCreateSignedChatAttachmentURL(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * fetchImageFromURL assets
   *
   * @remarks
   * Fetch an image from a URL and upload it to Speakeasy as an image asset.
   */
  async fetchImageFromURL(
    request: FetchImageFromURLRequest,
    security?: FetchImageFromURLSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadImageResult> {
    return unwrapAsync(assetsFetchImageFromURL(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * fetchOpenAPIv3FromURL assets
   *
   * @remarks
   * Fetch an OpenAPI v3 document from a URL and upload it to Speakeasy.
   */
  async fetchOpenAPIv3FromURL(
    request: FetchOpenAPIv3FromURLRequest,
    security?: FetchOpenAPIv3FromURLSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadOpenAPIv3Result> {
    return unwrapAsync(assetsFetchOpenAPIv3FromURL(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAssets assets
   *
   * @remarks
   * List all assets for a project.
   */
  async listAssets(
    request?: ListAssetsRequest | undefined,
    security?: ListAssetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAssetsResult> {
    return unwrapAsync(assetsListAssets(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * serveChatAttachment assets
   *
   * @remarks
   * Serve a chat attachment from Speakeasy.
   */
  async serveChatAttachment(
    request: ServeChatAttachmentRequest,
    security?: ServeChatAttachmentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ServeChatAttachmentResponse> {
    return unwrapAsync(assetsServeChatAttachment(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * serveChatAttachmentSigned assets
   *
   * @remarks
   * Serve a chat attachment using a signed URL token.
   */
  async serveChatAttachmentSigned(
    request: ServeChatAttachmentSignedRequest,
    options?: RequestOptions,
  ): Promise<ServeChatAttachmentSignedResponse> {
    return unwrapAsync(assetsServeChatAttachmentSigned(
      this,
      request,
      options,
    ));
  }

  /**
   * serveFunction assets
   *
   * @remarks
   * Serve a Speakeasy Functions asset from Speakeasy.
   */
  async serveFunction(
    request: ServeFunctionRequest,
    security?: ServeFunctionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ServeFunctionResponse> {
    return unwrapAsync(assetsServeFunction(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * serveImage assets
   *
   * @remarks
   * Serve an image from Speakeasy.
   */
  async serveImage(
    request: ServeImageRequest,
    options?: RequestOptions,
  ): Promise<ServeImageResponse> {
    return unwrapAsync(assetsServeImage(
      this,
      request,
      options,
    ));
  }

  /**
   * serveOpenAPIv3 assets
   *
   * @remarks
   * Serve an OpenAPIv3 asset from Speakeasy.
   */
  async serveOpenAPIv3(
    request: ServeOpenAPIv3Request,
    security?: ServeOpenAPIv3Security | undefined,
    options?: RequestOptions,
  ): Promise<ServeOpenAPIv3Response> {
    return unwrapAsync(assetsServeOpenAPIv3(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * uploadChatAttachment assets
   *
   * @remarks
   * Upload a chat attachment to Speakeasy.
   */
  async uploadChatAttachment(
    request: UploadChatAttachmentRequest,
    security?: UploadChatAttachmentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadChatAttachmentResult> {
    return unwrapAsync(assetsUploadChatAttachment(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * uploadFunctions assets
   *
   * @remarks
   * Upload functions to Speakeasy.
   */
  async uploadFunctions(
    request: UploadFunctionsRequest,
    security?: UploadFunctionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadFunctionsResult> {
    return unwrapAsync(assetsUploadFunctions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * uploadImage assets
   *
   * @remarks
   * Upload an image to Speakeasy.
   */
  async uploadImage(
    request: UploadImageRequest,
    security?: UploadImageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadImageResult> {
    return unwrapAsync(assetsUploadImage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * uploadOpenAPIv3 assets
   *
   * @remarks
   * Upload an OpenAPI v3 document to Speakeasy.
   */
  async uploadOpenAPIv3(
    request: UploadOpenAPIv3AssetRequest,
    security?: UploadOpenAPIv3AssetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadOpenAPIv3Result> {
    return unwrapAsync(assetsUploadOpenAPIv3(
      this,
      request,
      security,
      options,
    ));
  }
}
